<template>
  <div class="empty-book-section">
    <div class="grid grid--wide">
      <h2 class="xs-12 dea-heading--medium-xxl">I miei libri</h2>
    </div>
    <div class="empty-book-section__container">
      <div class="grid grid--wide">
        <h2 class="xs-12 dea-heading--regular-xxl">
          <template v-if="student">
            Qui troverai i libri che attiverai!
          </template>
          <template v-else>
            Qui troverai i libri che attiverai per la tua famiglia!
          </template>
        </h2>
        <EmptyBook
          align="horizontal"
          :link-color="linkColor"
          :parent="parent"
          :student="student"
          @open-activation-modal="$emit('open-activation-modal')"
          @open-evaluation-modal="$emit('open-evaluation-modal')"
        >
          <div class="dea-heading--medium-xl myhome-empty-book__title">
            Se hai già una copia di un libro tra le mani, attivala subito!
          </div>
        </EmptyBook>
      </div>
    </div>
  </div>
</template>

<script>
import EmptyBook from "~/components/books/components/EmptyBook";

export default {
  name: "EmptyFamilyStudentBookPage",
  components: { EmptyBook },
  props: {
    linkColor: {
      type: String,
      default: "",
    },
    parent: {
      type: Boolean,
      default: false,
    },
    student: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    subjectLink(subject) {
      let target;
      if (this.student) target = "studente";
      else if (this.parent) target = "famiglia";
      else target = "docente";
      return `${this.$root.config.publicURL}/work/materia/${subject.id}/${target}/`;
    },
  },
};
</script>
